import { validateOptionsResponse, validateScriptResponse } from './validation.ts';
import type { DraftOptionsResponse, DraftScriptRequest, DraftScriptResponse } from './types.ts';

export async function fetchDraftOptions(idea: string, signal?: AbortSignal): Promise<DraftOptionsResponse> {
  const payload = await postJson<unknown>('/api/draft-script/options', { idea }, signal);
  return validateOptionsResponse(payload);
}

export async function fetchDraftScript(request: DraftScriptRequest, signal?: AbortSignal): Promise<DraftScriptResponse> {
  const payload = await postJson<unknown>('/api/draft-script/generate', request, signal);
  return validateScriptResponse(payload);
}

async function postJson<T>(url: string, body: unknown, signal?: AbortSignal): Promise<T> {
  let response: Response;
  try {
    response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
      signal,
    });
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      throw error;
    }
    throw new Error('The draft service is unavailable. Try again.');
  }

  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const message = isRecord(payload) && typeof payload.message === 'string' ? payload.message : 'The draft service returned an error.';
    throw new Error(message);
  }
  return payload as T;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
